import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";

let isConfigured = false;

export const setMUIClassNamePrefix = (projectType) => {
  if (isConfigured) {
    return;
  }
  const projectAcronym = Number(projectType) === 8 ? 'pf' : 'cf';  
  ClassNameGenerator.configure((componentName) => `norstella-${projectAcronym}-${componentName}`);
  isConfigured = true;
};

ClassNameGenerator.configure((componentName) => `norstella-cf-${componentName}`);
